import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[luiListItemIcon]',
    standalone: false
})
export class ListItemIconDirective {
  @HostBinding('class') className = 'list-item-icon';
}
